export enum IconTypeEnum {
  TOKEN = 'token',
  RANK = 'rank',
  LEVEL = 'level',
  XP = 'xp',
}
